import { AxiosError, AxiosResponse } from "axios";
import { IExpensesData } from "../../interfaces/IExpenses";
import protheusProvider from "../providers/protheus.provider";
import nodeProvider from "../providers/node.provider";

export class ExpensesService {
  public async getProjectExpense(token: string | null, code: string): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.get('/expenses/project', {
        params: {
          token,
          code
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getExpense(token: string | null, osNumber: string | undefined): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.get(`/expenses/os/${osNumber}`, {
        params: {
          token
        }
      });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async launchExpense(token: string | null, objectParams: any): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.post('/expenses', { ...objectParams, token });
      return response;
    }
    catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async updateExpense(token: string | null, id: number, despesa: any): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.put(`/expenses/${id}`, {
        despesa,
        token
      });
      return response;
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async deleteExpense(token: string | null, id: number): Promise<AxiosResponse> {
    try {
      // Pass token in query params or body? DELETE usually query or header. 
      // Controller reads `req.query.token`.
      const response = await nodeProvider.delete(`/expenses/${id}`, {
        params: { token }
      });
      return response;
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }

  public async getExpenseImage(token: string | null, id: number): Promise<AxiosResponse> {
    try {
      const response = await nodeProvider.get(`/expenses/image/${id}`, {
        params: { token }
      });
      return response;
    } catch (ex) {
      const { response } = ex as AxiosError;
      return response!;
    }
  }
}